import React, { useEffect, useState } from "react";
import "./index.less";
import { Link, useLocation } from "react-router-dom"; // 添加 useLocation
import logo from "../../assets/nav_logo.png";
import WLogo from "../../assets/bottom-logo.png";
import codeOne from "../../assets/scancode-1.jpg";
import codeTwo from "../../assets/scancode-2.png";
import { fetch } from "@/utils/common";
import { useDispatch, useSelector } from "react-redux";
import { changeState, getters } from "@/store/data/global";
import { useNavigate } from "react-router-dom";

const BottomPage = (props) => {
  const navigate = useNavigate();
  const { contactInfo } = useSelector(getters);

  const [navList, setNavList] = useState([
    {
      id: "main-nav",
      category: "AI服务器",
      children: [],
    },
    {
      id: "main-nav",
      category: "解决方案",
      children: [],
    },
    {
      id: "main-nav",
      category: "新闻中心",
      children: [
        {
          path: "/news",
          id: 1,
          name: "公司新闻",
        },
        // {
        //   path: "/news",
        //   id: 2,
        //   name: "行业新闻",
        // },
      ],
    },
    {
      id: "main-nav",
      category: "关于信维",
      children: [
        {
          path: "/about",
          id: 1,
          name: "公司简介",
        },
        {
          path: "/about",
          id: 2,
          key: "/",
          name: "联系我们",
        },
      ],
    },
  ]);
  const location = useLocation(); // 获取当前路由信息
  const dispatch = useDispatch();

  const getSolutionCate = async () => {
    const { msg_list } = await fetch({
      url: "/type/get_list",
      method: "post",
      data: { data: { type: 4 } },
    });
    const list = msg_list.map((val) => {
      return {
        name: val.typeName,
        path: `/solution`,
        id: val.typeId,
        label: val.typeName,
        ...val,
      };
    });
    const { msg_list: productCates } = await fetch({ url: "/type/get_list/5" });
    let productCatesList = productCates.map((val) => {
      return {
        path: "/AIServer#product-category",
        id: val.typeId,
        name: val.typeName,
      };
    });
    for (let item of navList) {
      if (item.category === "AI服务器") {
        item.children = productCatesList;
      }
      if (item.category === "解决方案") {
        item.children = list;
      }
    }
    setNavList(navList);
    dispatch(changeState({ solutionCates: list }));
    // setSolutionCate(list);
  };

  const getContactInfo = async () => {
    try {
      const response = await fetch({ url: "/contact_us/detail" });
      dispatch(changeState({ contactInfo: response }));
    } catch (error) {
      console.error("获取联系信息失败:", error);
    }
  };

  useEffect(() => {
    getSolutionCate();
    getContactInfo();
  }, []);

  // 判断当前是否为Services或Nous页面
  const isDarkThemePage =
    location.pathname === "/services" || location.pathname === "/Nous";

  return (
    <footer
      className={`global-footer ${
        isDarkThemePage ? "dark-theme" : "light-theme"
      }`}
    >
      <div className="themesCube middle">
        <div className="top-link flex">
          <div className="card-cube">
            <Link to="/">
              <div className="logo">
                {isDarkThemePage ? (
                  <img src={WLogo} alt="Company Logo" />
                ) : (
                  <img src={logo} alt="Company Logo" />
                )}
              </div>
            </Link>
            <div className="QR-code flex">
              <div className="code">
                <div className="code-in">
                  <img src={codeOne} alt="Company Logo" />
                </div>
                <p>信维智算公众号</p>
              </div>
              <div className="code">
                <div className="code-in">
                  <img src={codeTwo} alt="Company Logo" />
                </div>
                <p>维云云设备公众号</p>
              </div>
            </div>
          </div>
          <div className="leftLink">
            {navList.map((val, index) => (
              <dl key={val.id} className="item-in">
                <dt>{val.category}</dt>
                {val.children.map((v, childIndex) => {
                  // 判断是否是 AI服务器 的子集（产品分类）
                  const isAIServerChild = val.category === "AI服务器";
                  
                  return (
                    <dd key={`${index}-${childIndex}`}>
                      <a
                        href={v.path}
                        onClick={(e) => {
                          e.preventDefault();
                          
                          // AI服务器的子集保持原有逻辑（锚点跳转）
                          if (isAIServerChild) {
                            const [path, hash] = v.path.split('#');
                            if (hash) {
                              // 先导航到页面，传递 state
                              navigate(path, { 
                                state: { type: v.id, anchor: hash }
                              });
                              // 然后设置 hash，触发滚动
                              setTimeout(() => {
                                window.location.hash = hash;
                              }, 100);
                            } else {
                              navigate(v.path, { state: { type: v.id } });
                            }
                          } else {
                            // 其他链接：即使当前页面也要刷新+返回顶部
                            const [path, hash] = v.path.split('#');
                            const currentPath = location.pathname;
                            
                            // 判断是否是当前页面
                            const isCurrentPage = currentPath === path || currentPath === v.path;
                            
                            if (isCurrentPage) {
                              // 当前页面：刷新+返回顶部
                              // 立即返回顶部（不使用动画，确保彻底）
                              window.scrollTo(0, 0);
                              document.documentElement.scrollTop = 0;
                              document.body.scrollTop = 0;
                              
                              // 确保所有滚动容器都回到顶部
                              const scrollableElements = document.querySelectorAll('[data-scroll-container], .snap-container, [style*="overflow"]');
                              scrollableElements.forEach(el => {
                                if (el.scrollTop !== undefined) {
                                  el.scrollTop = 0;
                                }
                              });
                              
                              // 使用 navigate 刷新页面，传递 state: { type: v.id }
                              if (hash) {
                                // 有 hash：刷新后保留 hash 和 state
                                navigate(path, { 
                                  state: { type: v.id, anchor: hash },
                                  replace: true
                                });
                                setTimeout(() => {
                                  window.location.hash = hash;
                                  // 强制刷新以重新加载数据
                                  window.location.reload();
                                }, 50);
                              } else {
                                // 没有 hash：使用 navigate 传递 state，然后刷新
                                navigate(path, { 
                                  state: { type: v.id },
                                  replace: true
                                });
                                setTimeout(() => {
                                  // 强制刷新以重新加载数据
                                  window.location.reload();
                                }, 50);
                              }
                            } else {
                              // 非当前页面：正常导航
                              if (hash) {
                                navigate(path, { 
                                  state: { type: v.id, anchor: hash }
                                });
                                setTimeout(() => {
                                  window.location.hash = hash;
                                }, 100);
                              } else {
                                navigate(v.path, { 
                                  state: { type: v.id }
                                });
                              }
                            }
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {v.name}
                      </a>
                    </dd>
                  );
                })}
              </dl>
            ))}
          </div>
          <div className="rightMessage">
            <h5>联系我们</h5>
            <div className="message">
              <div className="line">
                <span className="name">总机号码</span> : {contactInfo?.msg5}
              </div>
              {/* <div className="line">
                {' '}
                <span className="name">400电话</span> : {contactInfo?.msg5}
              </div> */}
              <div className="line">
                <span className="name">售后部门</span> : {contactInfo?.msg4}
              </div>
              <div className="line">
                <span className="name">传真号码</span> : {contactInfo?.msg6}
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-stowage flex">
          <div className="stowage">版权所有 广州信维电子科技股份有限公司 |</div>
          <div className="stowage">
            <Link target="_blank" to="http://beian.miit.gov.cn/">
              {" "}
              粤ICP备10023868号 |{" "}
            </Link>
          </div>
          <div className="stowage">
            <Link
              target="_blank"
              to="http://beian.miit.gov.cn/portal/registerSystemInfo?recordcode=44011602000125"
            >
              {" "}
              粤公网安备44011602000125号
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BottomPage;
